import { useState } from "react";
import { Replace } from "lucide-react";
import { toast } from "sonner";
import { adminRenameMasterField } from "@/lib/api";

const LABELS = { brand: "Marca", category: "Categoría", subcategory: "Subcategoría" };

export const RenameTool = ({ onDone }) => {
  const [field, setField] = useState("brand");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!from.trim() || !to.trim()) return toast.error("Escribe el valor actual y el nuevo");
    if (!window.confirm(`¿Renombrar ${LABELS[field].toLowerCase()} "${from}" → "${to}" en todo el catálogo?`)) return;
    setBusy(true);
    try {
      const r = await adminRenameMasterField(field, from, to);
      toast.success(`${r.modified} productos actualizados`);
      setFrom(""); setTo("");
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo renombrar");
    } finally { setBusy(false); }
  };

  return (
    <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-4 flex flex-col md:flex-row md:items-end gap-3" data-testid="mp-rename-tool">
      <div className="flex items-center gap-2 text-white/50 text-[10px] font-mono uppercase tracking-widest md:pb-2"><Replace size={14} className="text-[#ccff00]" /> Renombrar en masa</div>
      <select value={field} onChange={(e) => setField(e.target.value)} className="bg-black/60 border border-white/10 rounded-xl px-3 py-2 text-sm" data-testid="mp-rename-field">
        {Object.entries(LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <input value={from} onChange={(e) => setFrom(e.target.value)} placeholder="Valor actual (ej. Coca Cola)" className="flex-1 bg-black/60 border border-white/10 rounded-xl px-3 py-2 text-sm outline-none" data-testid="mp-rename-from" />
      <input value={to} onChange={(e) => setTo(e.target.value)} placeholder="Nuevo valor (ej. Coca-Cola)" className="flex-1 bg-black/60 border border-white/10 rounded-xl px-3 py-2 text-sm outline-none" data-testid="mp-rename-to" />
      <button onClick={run} disabled={busy} className="px-4 py-2 rounded-full border border-[#ccff00]/40 text-[#ccff00] text-[10px] font-mono uppercase tracking-widest hover:bg-[#ccff00]/10 disabled:opacity-50" data-testid="mp-rename-run">
        {busy ? "…" : "Aplicar"}
      </button>
    </div>
  );
};
